import React from "react";

const PageLoader = () => (
  <div className="min-h-[40vh] flex items-center justify-center text-secondary text-sm tracking-[0.2em] uppercase">
    Loading…
  </div>
);

export default PageLoader;
